// Presentation metadata for the five states a job can be in.
//
// Kept out of the components because two of them need it: StatusBadge draws
// the pill, JobCard draws the 3px rail down the card's left edge, and they must
// not be able to disagree about what colour "Error" is.
//
// This is DISPLAY state, not the database's Python_Files.status -- the four
// tabs collapse statuses 1 (Queued) and 2 (Busy) into one "Busy / Queue" view,
// so there is no one-to-one mapping.
//
// Deliberately identical to the file of the same name in the sibling RIC BGO
// Tool: the two apps are meant to signal status the same way.

export const STATUS_META = {
  ready: {
    label: "Ready",
    badge: "bg-info/10 text-info",
    rail: "oklch(var(--in))",
  },
  queued: {
    label: "Queued",
    badge: "bg-warning/20 text-warning-content",
    rail: "oklch(var(--wa))",
  },
  busy: {
    label: "Busy",
    badge: "bg-warning/20 text-warning-content",
    rail: "oklch(var(--wa))",
  },
  solved: {
    label: "Solved",
    badge: "bg-success/10 text-success",
    rail: "oklch(var(--su))",
  },
  error: {
    label: "Error",
    badge: "bg-error/10 text-error",
    rail: "oklch(var(--er))",
  },
};

/** Falls back to `ready` rather than throwing: a missing badge is a cosmetic
 *  bug, an exception in a list row blanks the page. */
export function statusMeta(status) {
  return STATUS_META[status] ?? STATUS_META.ready;
}
